import idx from 'idx'

export const filters = state => state.familyAlbum.filters

export const query = state => idx(state, _ => _.routing.locationBeforeTransitions.query)
